import React from 'react'
import {Switch,Route, Redirect} from "react-router-dom";
import CreateSite from './pages/CreateSite'
import Administration from './pages/Administration'
import ManageCenter from './pages/ManageCenter'
import Settings from './pages/Settings'

const Router = () =>
    (
    <Switch>
        <Route exact path='/CreateSite' component={CreateSite}/>
        <Route exact path='/Administration' component={Administration}/>
        <Route exact path='/ManageCenter' component={ManageCenter}/>
        <Route exact path='/ManageCenter/QARTask' component={ManageCenter}/>
        <Route exact path='/Settings' component={Settings}/>/
        {/*<Route exact path= '/TestCenter' component={TestCenter}/>*/}
        <Redirect exact from="/" to="CreateSite" />
    </Switch>
    )

export default Router


// WEBPACK FOOTER //
// ./src/Router.js